module.exports = __webpack_public_path__ + "img/magazine47.36a81b6e.jpg";